import React from "react";
import CompanyAdmin from "../../../../Components/CompanyAdmin/CompanyAdmin";

const Common_Company_Admin = () => {
  return <div><CompanyAdmin/></div>;
};

export default Common_Company_Admin;
